import '../../../../../components/Admin/Modals/AdminModal.scss';

import { Input, Modal } from '@trackman/web-shared-components';
import { useEffect, useState } from 'react';

import Paragraph from 'components/TextComps/Paragraph';

type Props = {
  open: boolean;
  title: string;
  contextLabel?: string;
  initialValue: string;
  errorMessage?: string;
  onCancel: () => void;
  onSave: (value: string) => void;
};

export const TitleFormModal = ({ open, title, contextLabel, initialValue, errorMessage, onCancel, onSave }: Props) => {
  const [value, setValue] = useState(initialValue);

  useEffect(() => {
    if (open) {
      setValue(initialValue);
    }
  }, [open, initialValue]);

  const trimmedValue = value.trim();

  const handleConfirm = () => {
    if (trimmedValue) {
      onSave(trimmedValue);
    }
  };

  return (
    <Modal
      className='admin-modal'
      open={open}
      title={title}
      onClose={onCancel}
      cancelBtn={{ label: 'Cancel', onClick: onCancel }}
      confirmBtn={{ label: 'Save changes', onClick: handleConfirm, disabled: !trimmedValue }}
    >
      <div className='modal-body'>
        {contextLabel ? (
          <Paragraph className='category-modal-context'>
            <>{contextLabel}</>
          </Paragraph>
        ) : (
          <></>
        )}
        <Input
          label='Title'
          value={value}
          onChange={(e) => setValue(e.currentTarget.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault();
              handleConfirm();
            }
          }}
        />
        {errorMessage ? (
          <Paragraph className='category-modal-error'>
            <>{errorMessage}</>
          </Paragraph>
        ) : (
          <></>
        )}
      </div>
    </Modal>
  );
};

export default TitleFormModal;
